const Footer = () =>{
    return(
        <footer>
        <h5>(c) Hey, Neighbor, SABR Project team, 2022</h5>
      </footer>
    )
    }
    export default Footer